import React from 'react';

// components
import TextInput from './components/TextInput';
import Textarea from './components/Textarea';
import Checkbox from './components/Checkbox';
import Select from './components/Select';
import RadioButtons from './components/RadioButtons';
import DatePickerField from './components/DatePickerField';
import FileUpload from './components/FileUpload';
import Password from './components/Password';
import MultiSelectDropdownField from './components/MultiSelectDropdown';
import SwitchField from './components/SwitchField';

// components

const FormField = ({ type, ...props }) => {
    switch (type) {
        case 'text':
        case 'email':
        case 'number':
        case 'numeric':
            return <TextInput {...props} type={type} />;
        case 'password':
            return <Password {...props} type={type} />;
        case 'select':
            return <Select {...props} />;
        case 'checkbox':
            return <Checkbox {...props} />;
        case 'radio':
            return <RadioButtons {...props} />;
        case 'textarea':
            return <Textarea {...props} />;
        case 'datepicker':
            return <DatePickerField {...props} />;
        case 'fileupload':
            return <FileUpload {...props} />;
        case 'multiselect':
            return <MultiSelectDropdownField {...props} />;
        case 'switch':
            return <SwitchField {...props} />;
        default:
            return <TextInput {...props} type="text" />;
    }
};

export default FormField;